import { Box } from '@mui/material';
import image from '../../assets/not-found.png';

const PageNotFound = () => {
  return (
    <Box className='flex items-center justify-center flex-col w-screen h-screen gap-2 overflow-hidden p-5'>
      <img
        src={image}
        alt=''
        className='w-[300px] h-auto object-contain object-center'
      />
      <h2 className='mt-5 text-center'>ページが見つかりません</h2>
      <span className='text-center'>
        申し訳ありませんが、お探しのページは存在しません。
      </span>
    </Box>
  );
};

export default PageNotFound;
